export class APIError extends Error {
    statusCode: number;
    error: string;

    private constructor(statusCode: number, error: string, message: string) {
        super(message);
        this.statusCode = statusCode;
        this.error = error;
    }

    static fromResponse(res: { statusCode: number; error: string; message: string }) {
        return new APIError(res.statusCode, res.error, res.message);
    }

    static default() {
        return new APIError(500, 'Internal Server Error', 'Internal Server Error');
    }
}
